// Global mixin for vehicle tracking across all pages
export default {
  methods: {
    // Track vehicle view globally
    trackVehicleView(vehicleId, vehicleData) {
      // Emit to root component or use event bus
      this.$root.$emit('vehicle-viewed', {
        vehicle_id: vehicleId,
        vehicle_data: vehicleData,
        page: this.$route.name || this.$route.path,
        timestamp: new Date().toISOString()
      });
      
      console.log('Vehicle tracked globally:', vehicleId, vehicleData);
    },

    // Track vehicle detail page view
    trackVehicleDetailView(vehicleId, fullVehicleData) {
      this.$root.$emit('vehicle-detail-viewed', {
        vehicle_id: vehicleId,
        vehicle_data: fullVehicleData,
        page: this.$route.name || this.$route.path,
        timestamp: new Date().toISOString()
      });
      
      console.log('Vehicle detail tracked:', vehicleId, fullVehicleData);
    },

    // Track vehicle search/filter actions
    trackVehicleSearch(searchParams) {
      this.$root.$emit('vehicle-search', {
        search_params: searchParams,
        page: this.$route.name || this.$route.path,
        timestamp: new Date().toISOString()
      });
      
      console.log('Vehicle search tracked:', searchParams);
    }
  }
}
